import React, {useContext} from "react";
import "./LoginPage.css";
import { FaUser, FaLock } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";
import { ApiUrl } from "../../utils/Properties";
import Swal from "sweetalert2";
import axios from "axios";

function LoginPage() {

  document.body.classList.add("background-login-page");

  const { loginUser } = useContext(AuthContext);
  const handleSubmit = (e) => {
    e.preventDefault();
    const username = e.target.username.value;
    const password = e.target.password.value;

    username.length > 0 && loginUser(username, password);
  };

  const recoverPassAction = () => {

    Swal.fire({
      title: "Ingrese su numero de identificación",
      input: "text",
      inputAttributes: {
        autocapitalize: "off"
      },
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Recuperar Contraseña",
      showLoaderOnConfirm: true,
      preConfirm: async (username) => {
        let data_response = null;
        try {
          const validateUsernameUrl = `
            ${ApiUrl}/api/users/validate/${username}
          `;
          const response = await axios.get(validateUsernameUrl);
          if (response.status !== 200) {
            return Swal.showValidationMessage('El usuario no existe, revise los datos ingresados e intente nuevamente.');
          }
          data_response = response.data;
        } catch (error) {
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
        
        try {
          const recoverPassUrl = `${ApiUrl}/auth/users/reset_password/`;
          const response = await axios.post(recoverPassUrl, {email: data_response.email});
          if (response.status !== 204) {
            return Swal.showValidationMessage('No se pudo realizar la solicitud, intente nuevamente.');
          }
          return data_response;
        } catch (error) {
          return Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }

      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Proceso realizado correctamente',
          text: 'Se envio un correo de recuperación de contraseña a su correo electrónico: ' + result.value.hidden_email,
        });
      }
    });

  };


  return (
    <div className="wrapper">
      <form onSubmit={handleSubmit}>
        <h1>Login</h1>
        <div className="input-box">
          <input type="text" placeholder="Username" name="username" required />
          <FaUser className="icon" />
        </div>
        <div className="input-box">
          <input type="password" placeholder="Password" name="password" required />
          <FaLock className="icon" />
        </div>

        <div className="remember-forgot">
          <label htmlFor="">
            <input type="checkbox" />
            Recuerdame
          </label>
          <a href="#" onClick={recoverPassAction}>Olvido su contraseña?</a>
        </div>

        <button type="submit">Login</button>

        <div className="register-link">
          <p>
            Desarrollado por{" "}
            <a href="https://www.nosolotec.com/" target="_blank">
              Nosolotec SA
            </a>
          </p>
        </div>
        <span className="note">
          Nota: Si es primera vez que ingresa, su usuario y contraseña es su numero de identificación de su factura.
        </span>
      </form>
    </div>
  );
}

export default LoginPage;
